import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const invoicePromise = import("./InvoicePage.js");
export default Auth(lazy(() => invoicePromise));
